import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { is, Map } from 'immutable';
import ReduxRecord from './reduxRecord';
import { getSessionItemById } from '../selectors/sessionItems';
export var SessionItemResult = /*#__PURE__*/function (_ReduxRecord) {
  function SessionItemResult() {
    _classCallCheck(this, SessionItemResult);
    return _callSuper(this, SessionItemResult, arguments);
  }
  _inherits(SessionItemResult, _ReduxRecord);
  return _createClass(SessionItemResult, [{
    key: "getItem",
    value: function getItem() {
      return getSessionItemById(this.getState(), this.id).getItem();
    }
  }, {
    key: "defaultResult",
    value: function defaultResult(sessionItem) {
      var defaultResultData = {
        attempt: 1,
        itemId: sessionItem.getItem().id,
        position: sessionItem.position,
        id: sessionItem.id
      };
      return new SessionItemResult(defaultResultData, this.getState());
    }
  }, {
    key: "getWorkingInstance",
    value: function getWorkingInstance() {
      var modificationData = this.merge(this.getState().getIn(['modifications', 'sessionItemResults', this.id], Map()));
      return new SessionItemResult(modificationData, this.getState());
    }
  }, {
    key: "hasModifications",
    value: function hasModifications() {
      return !is(this.getWorkingInstance(), this);
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return this.itemId !== null;
    }
  }, {
    key: "isGraded",
    value: function isGraded() {
      return !!this.gradedAt;
    }
  }]);
}(ReduxRecord({
  answerFeedback: null,
  attempt: null,
  feedback: Map(),
  gradedAt: null,
  graderId: null,
  gradingMethod: null,
  id: null,
  itemId: null,
  regradeInfo: null,
  pointsPossible: null,
  position: null,
  score: null,
  scoredData: Map()
}));
export default SessionItemResult;